import { type VariantProps, cva } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/80',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'border text-foreground',
        blue: 'ring-1 ring-inset bg-blue-50 text-blue-700 ring-blue-700/10',
        indigo: 'ring-1 ring-inset bg-indigo-50 text-indigo-700 ring-indigo-700/10',
        purple: 'ring-1 ring-inset bg-purple-50 text-purple-700 ring-purple-700/10',
        pink: 'ring-1 ring-inset bg-pink-50 text-pink-700 ring-pink-700/10',
        red: 'ring-1 ring-inset bg-red-50 text-red-700 ring-red-600/10',
        yellow: 'ring-1 ring-inset bg-yellow-50 text-yellow-800 ring-yellow-600/20',
        orange: 'ring-1 ring-inset bg-orange-50 text-orange-700 ring-orange-600/20',
        green: 'ring-1 ring-inset bg-green-50 text-green-700 ring-green-600/20',
        lime: 'ring-1 ring-inset bg-lime-50 text-lime-700 ring-lime-600/20',
        teal: 'ring-1 ring-inset bg-teal-50 text-teal-700 ring-teal-600/20',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
